import { Transforms } from 'slate';

import { getClosestTable } from '../../table/queries/getClosestTable';
import { getTableById } from '../../table/queries/getTableById';
import { TableEntry } from '../../table/types';

export function removeTable(editor: any, id?: string) {
  const table: TableEntry = id ? getTableById(editor, id) : getClosestTable(editor);

  if (table) {
    const [, path] = table;
    Transforms.removeNodes(editor, {
      at: [path[0]],
    });
  }
}
